import { render } from "./TopicDocs.vue?vue&type=template&id=34a531cd"
import script from "./TopicDocs.vue?vue&type=script&lang=js"
export * from "./TopicDocs.vue?vue&type=script&lang=js"

import "./TopicDocs.vue?vue&type=style&index=0&id=34a531cd&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__